const targetAllHTMLtags = RegExp(/<[^>]*>/g);
module.exports = {
  targetAllHTMLtags
};
